// convert all the code from vue2 to vue3
// https://next.vuex.vuejs.org/guide/migrating-to-4-0-from-3-x.html

// store.ts
import Vue from "vue";
import Vuex from "vuex";
import {
  StowagInstructionRequest,
  StowagInstructionDeck,
  StowagInstructionResponse,
  BayList,
  ColorBy,
  StowagInstructionContainerDetailResponse,
} from "./stowagInstruction.types";
import ApiService from "../api.service";
const Stowag_TOGGLE_CELL_PROPERTIES = "Stowag_TOGGLE_CELL_PROPERTIES";
const SET_STOWAGERROR = "setStowagError";

Vue.use(Vuex);

enum DeckEnum {
  Both = 1,
  Above = 2,
  Below = 3,
}

enum ViewEnum {
  SingleBay = 1,
  SingleColumn = 2,
  AllBays = 3,
}

interface State {
  errors: string[];
  loadingMessage: string;
  isStowagInstructionLoading: boolean[];
  StowagInstructionResponse: StowagInstructionResponse;
  StowagInstructionRequest: StowagInstructionRequest;
  StowagInstructionContainerDetailResponse: StowagInstructionContainerDetailResponse;
  isStowagInstructionContainerDetailModalOpen: boolean;
  decks: { id: number; name: string }[];
  bayList: BayList;
  colorByList: ColorBy[];
  currentColorSlected: string;
  currentStowage: any;
  voyageContainersList: any;
}

const state = {
  errors: [],
  loadingMessage: "loading",
  isStowagInstructionLoading: [],
  isStowagInstructionContainerDetailModalOpen: false,
  StowagInstructionRequest: {
    bay: 1,
    colorBy: 1,
    deck: StowagInstructionDeck.Both,
    status: 1,
    MonitoringType: 2,
    view: ViewEnum.AllBays,
    voyageId: 1,
  },
  StowagInstructionResponse: {
    isSuccessful: false,
    tag: "",
    deck: 1,
    message: [],
    data: {
      colorPalettes: [],
      vesselHatches: [
        {
          vesselBays: [],
          vesselProfileHatchId: 31,
        },
      ],
    },
  },
  StowagInstructionContainerDetailResponse: {
    data: {
      existed: true,
      containerNo: "",
      position: "",
      isoCode: "",
      lineOperator: "",
      containerType: "",
      length: "",
      status: "",
      height: "",
      teu: 1,
      weight: "",
      weightGroup: "",
      portOfLoad: "",
      portOfDischarge: "",
      polTerminal: "",
      podTerminal: "",
      destination: "",
      isHazardous: false,
      isOOG: false,
      bundle: false,
      isReefer: false,
      blink:false,
    },
    isSuccessful: true,
    tag: "",
    message: [],
    errorField: "",
  },
  decks: [
    {
      id: 1,
      name: "Both",
    },
    {
      id: 2,
      name: "Above",
    },
    {
      id: 3,
      name: "Below",
    },
  ],
  bayList: [],
  colorByList: [],
  currentColorSlected: null,
  currentStowage: null,
  voyageContainersList: null,
};

const getters = {
  getStowageErrors() {
    return state.errors;
  },
  getvoyageContainersList: function(state: State) {
    return state.voyageContainersList;
  },
  getcurrentStowage: function(state: State) {
    return state.currentStowage;
  },
  getcurrentColorSlected: function(state: State) {
    return state.currentColorSlected;
  },
  getIsStowagInstructionContainerDetailModalOpen: function(state: State) {
    return state.isStowagInstructionContainerDetailModalOpen;
  },
  getStowagInstructionContainerDetailResponse: function(state: State) {
    return state.StowagInstructionContainerDetailResponse.data;
  },
  getStowagInstructionLoadingMessage: function(state: State) {
    return state.loadingMessage;
  },
  getIsStowagInstructionLoading: function(state: State) {
    return state.isStowagInstructionLoading;
  },
  getStowagInstructionData: function(state: State) {
    return state.StowagInstructionResponse.data;
  },
  getStowagInstructionColorPalettes: function(state: State) {
    return state.StowagInstructionResponse.data.colorPalettes;
  },
  getStowagInstructionBayList: function(state) {
    return state.bayList;
  },
  getStowagInstructionResponse: function(state: State) {
    return state.StowagInstructionResponse;
  },
  getStowagInstructionSelectedView: function(state: State) {
    return state.StowagInstructionRequest.view;
  },
  getStowagInstructionSelectedDeck: function(state: State) {
    return state.StowagInstructionRequest.deck;
  },
  getStowagInstructionSelectedBay: function(state: State) {
    return state.StowagInstructionRequest.bay;
  },
  getStowagInstructionColorByList: function(state: State) {
    return state.colorByList;
  },
  // TODO : list decks dynamically from endpoint
  getStowagInstructionDecks: function(state) {
    return state.decks;
  },
  getStowagInstructionSelectedColorBy: function(state: State) {
    return state.StowagInstructionRequest.colorBy;
  },
};

const actions = {
  setWrong({ commit, state: State }, payload) {
    commit("setWrongs", true);
  },
  fetchvoyagecontainerslist({ commit, state: State }, payload) {
    commit("isStowagInstructionLoadingMutation", true);
    const stowagInstructionRequestbody = state.StowagInstructionRequest;
    return new Promise((resolve) => {
      ApiService.post("system/stowageinstruction/getvoyagecontainerslist", {
        ...payload,
        ...stowagInstructionRequestbody,
      })
        .then((response) => {
          if (response.data.isSuccessful) {
            commit("VoyageContainersList", response.data.data);
            commit("StowagInstruction2DBayViewMutation", response.data);
          } else {
            commit(SET_STOWAGERROR, response.data.message);
          }
          resolve(response);
        })
        .finally(() => {
         commit("isStowagInstructionLoadingMutation", false);
        });
    });
  },
  fetchvoyagecontainersbyid({ commit, state: State }, payload) {
    commit("isStowagInstructionLoadingMutation", true);
    
    ApiService.post(
      "system/stowageinstruction/getinfowithhatch",
      payload
    )
      .then((response) => {
        commit("VoyageContainersList", response.data.data);
        commit("StowagInstruction2DBayViewMutation", response.data);

      })
      .finally(() => {
         commit("isStowagInstructionLoadingMutation", false);
      });
  },
  getEditDetail({ commit, state: State }, payload) {
    commit("isStowagInstructionLoadingMutation", true);
    
    ApiService.post(
      "system/stowageinstruction/getEditDetail",
      payload
    )
      .then((response) => {
        commit("VoyageContainersList", response.data.data);
        commit("StowagInstruction2DBayViewMutation", response.data);

      })
      .finally(() => {
         commit("isStowagInstructionLoadingMutation", false);
      });
  },
  setCurrentStowagSelected({ commit, state: State }, payload) {
    commit("setCurrentStowagSelected", payload);
  },
  setCurrentColor({ commit, state: State }, payload) {
    commit("setCurrentColor", payload);
  },
  stowagtoggleCellProperty(
    { commit, state: State },
    {
      VesselHatchId,
      VesselbayId,
      bayType,
      cellIndex,
      currentStowageId,
      currentValue,
      stowageInstructionIs4045Foot
    }
  ) {
    commit(Stowag_TOGGLE_CELL_PROPERTIES, {
      VesselHatchId,
      VesselbayId,
      bayType,
      cellIndex,
      currentStowageId,
      currentValue,
      stowageInstructionIs4045Foot
    });
  },
  setIsStowagInstructionLoading({ commit, state: State }, payload) {
    commit("isStowagInstructionLoadingMutation", payload);
  },
  setLoadingMessage({ commit, state: State }, payload) {
    commit("loadingMessageMutation", payload);
  },
  getStowagInstructionContainerDetail({ commit, state: State }) {
    return state.StowagInstructionContainerDetailResponse.data;
  },
  setIsStowagInstructionContainerDetailModalOpen(
    { commit, state: State },
    payload
  ) {
    commit("isStowagInstructionContainerDetailModalOpenMutation", payload);
  },
  // Get vessel monitoring 2D bay view data
  fetchStowagInstruction2DBayView({ commit, state: State }) {
    const body = state.StowagInstructionRequest;
    commit("isStowagInstructionLoadingMutation", true);
    ApiService.post(
      "system/stowageInstruction/GetStowageInstruction2DBayView",
      body
    )
      .then((response) => {
        commit("StowagInstruction2DBayViewMutation", response.data);
      })
      .finally(() => {
        commit("isStowagInstructionLoadingMutation", false);
      });
  },

  fetchStowagInstruction2DBayEdit({ commit, state: State }, payload) {
    const body = state.StowagInstructionRequest;

    commit("isStowagInstructionLoadingMutation", true);
    ApiService.post(
      "system/stowageInstruction/GetStowageInstruction2DBayEdit",
      { ...body, ...payload }
    )
      .then((response) => {
        commit("StowagInstruction2DBayViewMutation", response.data);
      })
      .finally(() => {
        commit("isStowagInstructionLoadingMutation", false);
      });
  },
  /*   fetchStowagInstructionBayList({ commit, state }) {
    const voyageId = state.StowagInstructionRequest.voyageId;
    const queryStr = `?voyageId=${voyageId}`;
    commit("isStowagInstructionLoadingMutation", true);
    ApiService.get(
      "system/vesseloperationmonitoring/getallbaybyvoyageid",
      queryStr
    )
      .then((response) => {
        commit("StowagInstructionBayListMutation", response.data.data.bayList);
      })
      .finally(() => {
        commit("isStowagInstructionLoadingMutation", false);
      });
  }, */
  /*   fetchStowagInstructionColorByList({ commit }) {
    commit("isStowagInstructionLoadingMutation", true);
    ApiService.get(
      "system/vesseloperationmonitoring/getStowagInstructioncolorby"
    )
      .then((response) => {
        commit("StowagInstructionColorByMutation", response.data.data);
      })
      .finally(() => {
        commit("isStowagInstructionLoadingMutation", false);
      });
  }, */
  // TODO Get deck types for deck dropdown
  /*   fetchStowagInstructionDeck({ commit }) {
    commit("isStowagInstructionLoadingMutation", true);
    ApiService.get("system/vesseloperationmonitoring/getStowagInstructiondeck")
      .then((response) => {
        commit("updateDecksMutation", response.data);
      })
      .finally(() => {
        commit("isStowagInstructionLoadingMutation", false);
      });
  }, */
  setSelectedView({ commit, dispatch }, payload: ViewEnum) {
    commit("setSelectedViewMutation", payload);
    dispatch("fetchStowagInstruction2DBayView");
  },
  setSelectedDeck({ commit, dispatch }, payload: DeckEnum) {
    commit("setSelectedDeckMutation", payload);
    dispatch("fetchStowagInstruction2DBayView");
  },
  setSelectedBay({ commit, dispatch }, bay: number) {
    commit("setSelectedBayMutation", bay);
    dispatch("fetchStowagInstruction2DBayView");
  },
  setSelectedColorBy({ commit, dispatch }, colorBy: number) {
    commit("setSelectedColorByMutation", colorBy);
    dispatch("fetchStowagInstruction2DBayView");
  },
  setPropertiesFromQueryString(
    { commit, dispatch },
    { operationStatus, operationType }
  ) {
    commit("propertiesFromQueryStringMutation", {
      operationStatus,
      operationType,
    });
  },
};

const mutations = {
  setWrongs(state, error) {

   // const cell = state.StowagInstructionResponse.data.vesselHatches[0].vesselBays[1]?.onDeck.cells[0];
   
    
      //cell.blink = !cell.blink;
      state.StowagInstructionResponse.data.vesselHatches= state.StowagInstructionResponse.data.vesselHatches.map(vh => {
      vh.vesselBays.map(vb => {
        vb.onDeck.cells.map(cell => {
          if (cell.isLoadedWrongPosition) {
            
            cell.blink = !cell.blink;
          }
          return cell;
        });
        return vb;
      });
      return vh;
    });    
  },
  [SET_STOWAGERROR](state, error) {
    state.errors = error;
  },
  [Stowag_TOGGLE_CELL_PROPERTIES](
    state: State,
    {
      VesselHatchId,
      VesselbayId,
      bayType,
      cellIndex,
      currentStowageId,
      currentValue,
      stowageInstructionIs4045Foot
    }: {
      VesselHatchId: number;
      VesselbayId: number;
      bayType: string;
      cellIndex: number;
      currentStowageId: Number;
      currentValue: string;
      stowageInstructionIs4045Foot : number;
    }
  ) {
    const cell =
      state.StowagInstructionResponse.data.vesselHatches[VesselHatchId]
        .vesselBays[VesselbayId]?.[bayType].cells[cellIndex];
    cell.color = currentValue;
    cell.stowageInstructionDetailId = currentStowageId;
    cell.stowageInstructionIs4045Foot = stowageInstructionIs4045Foot
  },

  VoyageContainersList(state: State, payload: any) {
    state.voyageContainersList = payload;
  },
  VoyageContainersdetailsList(state: State, payload: any) {
    state.voyageContainersList.details = payload;
  },
  setCurrentStowagSelected(state: State, payload: Number) {
    state.currentStowage = payload;
  },
  setCurrentColor(state: State, payload: string) {
    state.currentColorSlected = payload;
  },
  isStowagInstructionContainerDetailModalOpenMutation(
    state: State,
    payload: boolean
  ) {
    state.isStowagInstructionContainerDetailModalOpen = payload;
  },
  containerDetailResponseMutation(state: State, payload) {
    state.StowagInstructionContainerDetailResponse = { ...payload };
  },
  loadingMessageMutation(state: State, payload) {
    state.loadingMessage = payload;
  },
  isStowagInstructionLoadingMutation(state: State, payload) {
    let TIMEOUT = 200;

    if (payload === false) {
      setTimeout(() => {
        state.isStowagInstructionLoading.pop();
      }, TIMEOUT);
    } else if (payload === true) {
      state.isStowagInstructionLoading.push(payload);
    }
  },
  StowagInstruction2DBayViewMutation(state: State, payload) {
    state.StowagInstructionResponse = payload;
  },
  StowagInstructionBayListMutation(state: State, payload) {
    state.bayList = payload;
  },
  StowagInstructionColorByMutation(state: State, payload) {
    state.colorByList = payload;
  },
  updateDecksMutation(state: State, payload: any) {
    state.decks = payload;
  },
  setSelectedBayMutation(state: State, payload: number) {
    state.StowagInstructionRequest.bay = Number(payload);
  },
  setSelectedDeckMutation(state: State, payload) {
    state.StowagInstructionRequest.deck = payload;
  },
  setVesselIdMutation(state: State, payload: number) {
    state.StowagInstructionRequest.voyageId = payload;
  },
  setSelectedColorByMutation(state: State, payload: number) {
    state.StowagInstructionRequest.colorBy = payload;
  },
  propertiesFromQueryStringMutation(
    state: State,
    payload: { operationStatus; operationType }
  ) {
    state.StowagInstructionRequest.status = payload.operationStatus;
    state.StowagInstructionRequest.MonitoringType = payload.operationType;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
